/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SignInImport } from './routes/sign-in'
import { Route as PaymentRedirectImport } from './routes/payment-redirect'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as PasswordResetTokenImport } from './routes/password-reset.$token'
import { Route as AuthFortuneWheelImport } from './routes/_auth.fortune-wheel'
import { Route as AuthCasinoImport } from './routes/_auth.casino'
import { Route as AuthGameGameIdImport } from './routes/_auth.game.$gameId'

// Create/Update Routes

const SignInRoute = SignInImport.update({
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any)

const PaymentRedirectRoute = PaymentRedirectImport.update({
  path: '/payment-redirect',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const PasswordResetTokenRoute = PasswordResetTokenImport.update({
  path: '/password-reset/$token',
  getParentRoute: () => rootRoute,
} as any)

const AuthFortuneWheelRoute = AuthFortuneWheelImport.update({
  path: '/fortune-wheel',
  getParentRoute: () => AuthRoute,
} as any)

const AuthCasinoRoute = AuthCasinoImport.update({
  path: '/casino',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGameGameIdRoute = AuthGameGameIdImport.update({
  path: '/game/$gameId',
  getParentRoute: () => AuthRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/payment-redirect': {
      preLoaderRoute: typeof PaymentRedirectImport
      parentRoute: typeof rootRoute
    }
    '/sign-in': {
      preLoaderRoute: typeof SignInImport
      parentRoute: typeof rootRoute
    }
    '/_auth/casino': {
      preLoaderRoute: typeof AuthCasinoImport
      parentRoute: typeof AuthImport
    }
    '/_auth/fortune-wheel': {
      preLoaderRoute: typeof AuthFortuneWheelImport
      parentRoute: typeof AuthImport
    }
    '/password-reset/$token': {
      preLoaderRoute: typeof PasswordResetTokenImport
      parentRoute: typeof rootRoute
    }
    '/_auth/game/$gameId': {
      preLoaderRoute: typeof AuthGameGameIdImport
      parentRoute: typeof AuthImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  AuthRoute.addChildren([
    AuthCasinoRoute,
    AuthFortuneWheelRoute,
    AuthGameGameIdRoute,
  ]),
  PaymentRedirectRoute,
  SignInRoute,
  PasswordResetTokenRoute,
])

/* prettier-ignore-end */
